<template>
    <div class="entriesContainer">
        <br/>
        <div
            class="listItemWrapper"
            v-for="(item, index) in listObject.index"
            :key="index"
        >
            <p>{{ item }}<p/>
        </div>
    </div>
</template>

<script>
export default {
    name: "List",
    props: {
        currentList: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            listObject: {},
        };
    },
    methods: {
        getListBySectionId(id) {
            this.listObject = this.$store.getters.getListBySectionId(id);
        },
    },
    watch: {
        currentList(newVal) {
            this.getListBySectionId(newVal);
        },
    },
};
</script>
